import React from 'react';
import { Box, Text, Button } from 'components/ui';
import uiUtils from 'utils/UI';
import ProductImage from 'components/Product/ProductImage/ProductImage';
import ProductQuicklook from 'components/Product/ProductQuicklook/ProductQuicklook';
import urlUtils from 'utils/Url';
import { getText } from 'components/ProductPage/ProductCompareTool/ProductCompareToolItem/compareItemLocale';
import { getComponentTitle, handleProductClick } from 'analytics/productPage/compareItemAnalytics';
import { styles, skeletonStyles } from 'components/ProductPage/ProductCompareTool/ProductCompareToolItem/compareItemStyles';

export const renderTopCell = ({
    sku, index, podId, isCarousel, isSkeleton
}) => {
    const { SKELETON_ANIMATION } = uiUtils;
    const componentTitle = getComponentTitle();
    const targetUrl = urlUtils.getLink(sku?.targetUrl);

    return (
        <Box
            key={`top-${index}`}
            backgroundColor={index === 0 && !isSkeleton && 'nearWhite'}
            borderLeftWidth={index > 0 && 1}
            borderColor={index > 0 && 'divider'}
            paddingTop={4}
            paddingLeft={4}
            paddingRight={4}
            {...(!isSkeleton &&
                sku?.strategyId && {
                'data-cnstrc-item': 'recommendation',
                'data-cnstrc-item-id': sku?.productId,
                'data-cnstrc-item-name': sku?.productName,
                'data-cnstrc-item-variation-id': sku?.variationId,
                'data-cnstrc-strategy-id': sku?.strategyId,
                'data-cnstrc-item-price': sku?.salePrice || sku?.listPrice
            })}
        >
            <div css={styles.cellTop}>
                <Box
                    position='relative'
                    marginBottom={4}
                    {...(!isSkeleton &&
                        index > 0 && {
                        ['aria-label']: `${sku.brandName} ${sku.productName}`,
                        href: targetUrl,
                        onClick: e => handleProductClick(e, sku, index, podId, isCarousel),
                        css: styles.ql
                    })}
                >
                    {isSkeleton ? (
                        <div css={[skeletonStyles.image, SKELETON_ANIMATION]} />
                    ) : (
                        <>
                            {sku?.skuId && (
                                <ProductImage
                                    id={sku.skuId}
                                    skuImages={sku.skuImages}
                                    size={160}
                                />
                            )}
                            {index > 0 && (
                                <div className='ProductTableItem-ql'>
                                    <ProductQuicklook
                                        isShown={true}
                                        showQuickLookOnMobile={true}
                                        rootContainerName={componentTitle}
                                        productStringContainerName={componentTitle}
                                        sku={sku}
                                        podId={podId}
                                        isCarousel={isCarousel}
                                    />
                                </div>
                            )}
                        </>
                    )}
                </Box>
                <Text
                    display='block'
                    fontSize={['xs', 'sm']}
                    marginBottom='.125em'
                    fontWeight='bold'
                    numberOfLines={1}
                    css={isSkeleton && [skeletonStyles.text, SKELETON_ANIMATION]}
                    children={isSkeleton ? ' ' : sku?.brandName}
                />
                <Text
                    display='block'
                    numberOfLines={2}
                    css={isSkeleton && [skeletonStyles.text, SKELETON_ANIMATION]}
                    children={isSkeleton ? ' ' : sku?.productName}
                />
                {isSkeleton ? (
                    <>
                        <div css={[skeletonStyles.price, SKELETON_ANIMATION]}>&nbsp;</div>
                        <div css={[skeletonStyles.button, SKELETON_ANIMATION]} />
                    </>
                ) : (
                    index > 0 && (
                        <Button
                            block={true}
                            size='sm'
                            marginTop='auto'
                            variant='secondary'
                            onClick={e => handleProductClick(e, sku, index, podId, isCarousel)}
                            href={targetUrl}
                            children={getText('seeDetails')}
                        />
                    )
                )}
            </div>
        </Box>
    );
};
